import React, { useMemo } from "react";
import { AvatarPersonIcon } from "../landing/icons";
import { competitionCopy } from "../landing/leagueFormat";

// The prompt to post, at the top of a league's feed.
//
// Tapping it opens the post modal over the league (see LeaguePostModal) rather
// than navigating to the old full-page editor — you never leave the league to
// write in it.
//
// Client Rev 2, desktop Private League Home 9: "The composer is showing the older
// treatment in this screenshot. Apply the changes we locked with the public league
// home screen desktop Rev: remove the three shortcut icons and Post to League
// button. Leave the thin avatar (not clickable to profile) + placeholder composer
// row. Entire collapsed composer row: clickable; opens the full composer modal."
//
// So what was a card with three attachment shortcuts and its own submit button is
// now ONE row that is itself the button. The three icons were only ever previews
// of what the modal contains — they opened the same modal the row does — and the
// submit button promised a send from a row that cannot compose anything.
//
// The avatar is deliberately inert: it sits inside the button, so it cannot be a
// link to a profile, which is what "not clickable to profile" asks for.
const LeagueComposer = ({ game, onOpen }) => {
  const avatar = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("userInfo") || "null")?.image || "";
    } catch (e) {
      return "";
    }
  }, []);

  return (
    <button
      type="button"
      onClick={() => onOpen?.()}
      className="w-full flex items-center gap-3 rounded-2xl border border-gray-200 bg-white p-4 text-left transition-colors hover:border-[#0F4146]"
    >
      {avatar ? (
        <img
          src={avatar}
          alt=""
          aria-hidden="true"
          className="w-9 h-9 rounded-full object-cover shrink-0 bg-[#F3F4F6]"
          onError={(e) => {
            e.currentTarget.style.visibility = "hidden";
          }}
        />
      ) : (
        <span className="w-9 h-9 rounded-full bg-[#F3F4F6] flex items-center justify-center shrink-0">
          <AvatarPersonIcon className="w-5 h-5" />
        </span>
      )}
      <span className="flex-1 min-w-0 truncate text-sm text-tertiary">
        {competitionCopy(game).composerPlaceholder}
      </span>
    </button>
  );
};

export default LeagueComposer;
